import React from 'react';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Slide from '@material-ui/core/Slide';
import Fade from '@material-ui/core/Fade';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLink } from '@fortawesome/pro-regular-svg-icons';

function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : String(i);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var getTitleColor = function getTitleColor(titleColor) {
  var secondaryToBlue = 'linear-gradient(165.32deg, #7357FF 0.08%, #96DDFA 96.67%)';
  var college = 'linear-gradient(165.32deg, #B23461 0.08%, #EC756D 96.67%)';
  return titleColor === 'secondaryToBlue' ? secondaryToBlue : college;
};
var getTitleStyle = function getTitleStyle(titleColor, theme) {
  return _defineProperty({
    color: 'transparent',
    background: titleColor,
    'background-clip': 'text',
    '-webkit-background-clip': 'text',
    '-webkit-text-fill-color': 'transparent',
    fontFamily: 'Roboto Slab',
    fontSize: '48px',
    lineHeight: '56px'
  }, theme.breakpoints.up('md'), {
    fontSize: '60px',
    lineHeight: '72px'
  });
};
// Title style needs to render as one full style block to for the gradient to work properly.
var useStyles$1 = makeStyles(function (theme) {
  return {
    title: function title(_ref2) {
      var titleColor = _ref2.titleColor;
      return getTitleStyle(getTitleColor(titleColor), theme);
    },
    subtitle: {
      color: 'black',
      fontFamily: 'Roboto',
      fontSize: '32px',
      fontWeight: 900,
      lineHeight: '40px'
    },
    body: {
      color: 'black',
      fontFamily: 'Roboto',
      fontSize: '16px',
      lineHeight: '24px'
    },
    scoirLink: {
      textDecoration: 'underline',
      display: 'inline-flex'
    }
  };
});
var TextContent = function TextContent(_ref3) {
  var title = _ref3.title,
    _ref3$titleColor = _ref3.titleColor,
    titleColor = _ref3$titleColor === void 0 ? 'secondaryToBlue' : _ref3$titleColor,
    subtitle = _ref3.subtitle,
    body = _ref3.body,
    buttonText = _ref3.buttonText,
    buttonStartIcon = _ref3.buttonStartIcon,
    buttonTo = _ref3.buttonTo,
    buttonHref = _ref3.buttonHref,
    _ref3$showLearnMoreLi = _ref3.showLearnMoreLink,
    showLearnMoreLink = _ref3$showLearnMoreLi === void 0 ? true : _ref3$showLearnMoreLi,
    _ref3$newTab = _ref3.newTab,
    newTab = _ref3$newTab === void 0 ? false : _ref3$newTab;
  var classNames = useStyles$1({
    titleColor: titleColor
  });
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Fade, {
    "in": true,
    timeout: 1500
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Slide, {
    direction: "right",
    "in": true,
    timeout: 1000,
    mountOnEnter: true,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement(Box, {
    maxWidth: "440px",
    minWidth: "300px",
    display: "inline-block"
  }, !title ? null : ( /*#__PURE__*/React.createElement(Box, {
    mb: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h1",
    className: classNames.title
  }, title))), !subtitle ? null : ( /*#__PURE__*/React.createElement(Box, {
    mb: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2",
    className: classNames.subtitle
  }, subtitle))), /*#__PURE__*/React.createElement(Box, {
    mb: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    className: classNames.body
  }, body)), !buttonText ? null : ( /*#__PURE__*/React.createElement(Box, {
    mb: 3
  }, /*#__PURE__*/React.createElement(Button, {
    to: buttonTo,
    href: buttonHref,
    component: buttonHref ? 'a' : Link,
    rel: buttonHref ? 'noopener noreferrer' : undefined,
    target: newTab ? '_blank' : undefined,
    color: "primary",
    variant: "contained"
  }, buttonStartIcon, /*#__PURE__*/React.createElement(Box, {
    ml: buttonStartIcon ? 1 : 0
  }, buttonText)))), showLearnMoreLink && ( /*#__PURE__*/React.createElement("a", {
    className: classNames.scoirLink,
    href: "https://www.scoir.com/students-families",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Learn more about Scoir", /*#__PURE__*/React.createElement(Box, {
    ml: 1
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faExternalLink
  })))))))));
};

var useStyles = makeStyles(function (theme) {
  return {
    artwork: _defineProperty(_defineProperty({
      maxWidth: '360px',
      minWidth: '300px',
      marginLeft: 0,
      marginBottom: '3rem'
    }, theme.breakpoints.down('sm'), {
      width: '100%'
    }), theme.breakpoints.up('md'), {
      marginLeft: '6rem',
      marginBottom: 0
    })
  };
});
var Artwork = function Artwork(_ref) {
  var src = _ref.src,
    alt = _ref.alt;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Box, {
    className: classes.artwork
  }, /*#__PURE__*/React.createElement(Fade, {
    "in": true,
    timeout: 1500
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Slide, {
    direction: "left",
    "in": true,
    timeout: 1000,
    mountOnEnter: true,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    width: "100%",
    src: src,
    alt: alt
  }))))));
};

var SplashPage = function SplashPage(_ref) {
  var title = _ref.title,
    _ref$titleColor = _ref.titleColor,
    titleColor = _ref$titleColor === void 0 ? 'secondaryToBlue' : _ref$titleColor,
    subtitle = _ref.subtitle,
    body = _ref.body,
    artwork = _ref.artwork,
    artworkProps = _ref.artworkProps,
    buttonText = _ref.buttonText,
    buttonStartIcon = _ref.buttonStartIcon,
    buttonTo = _ref.buttonTo,
    buttonHref = _ref.buttonHref,
    showLearnMoreLink = _ref.showLearnMoreLink,
    newTab = _ref.newTab;
  return /*#__PURE__*/React.createElement(Container, {
    maxWidth: "lg"
  }, /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    minHeight: "calc(100vh - 76px)",
    p: 3,
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    flexDirection: {
      xs: 'column-reverse',
      md: 'row'
    }
  }, /*#__PURE__*/React.createElement(TextContent, {
    title: title,
    titleColor: titleColor,
    subtitle: subtitle,
    body: body,
    buttonText: buttonText,
    buttonStartIcon: buttonStartIcon,
    buttonTo: buttonTo,
    buttonHref: buttonHref,
    showLearnMoreLink: showLearnMoreLink,
    newTab: newTab
  }), /*#__PURE__*/React.createElement(Artwork, Object.assign({
    src: artwork
  }, artworkProps))));
};

export { SplashPage as default };
//# sourceMappingURL=index.module.js.map
